import {
  BookOpen,
  Camera,
  Clock,
  CookingPot,
  FileDown,
  ListOrdered,
  Repeat,
  Scale,
  Wallet,
} from "lucide-react";
import type { Faq, Review } from "../types/product";

// Recensioni: sostituisci con foto, testi e nomi autentici delle clienti.
// Lascia "photo" vuoto per mostrare lo spazio da compilare.
export const reviews: Review[] = [
  {
    photo: undefined,
    quote: "[Inserisci qui il testo autentico della recensione della cliente]",
    name: "[Nome C.]",
    rating: 5,
  },
  {
    photo: undefined,
    quote: "[Inserisci qui il testo autentico della recensione della cliente]",
    name: "[Nome C.]",
    rating: 5,
  },
  {
    photo: undefined,
    quote: "[Inserisci qui il testo autentico della recensione della cliente]",
    name: "[Nome C.]",
    rating: 5,
  },
];

export const insideFeatures = [
  { icon: Camera, label: "Foto del prodotto finito" },
  { icon: Scale, label: "Ingredienti e dosi precise in grammi" },
  { icon: ListOrdered, label: "Metodo chiaro passo dopo passo, con temperature" },
  { icon: Clock, label: "Durata e conservazione del prodotto" },
  { icon: Wallet, label: "Costo stimato per lotto" },
  { icon: Repeat, label: "Varianti e possibili sostituzioni" },
];

export const insideCallouts = [
  { label: "Foto HD del prodotto", position: "right-3 top-4 sm:right-6 sm:top-8" },
  { label: "Dosi esatte", position: "left-3 top-[38%] sm:left-6" },
  { label: "Metodo passo dopo passo", position: "left-3 bottom-[22%] sm:left-6" },
];

export const steps = [
  {
    icon: FileDown,
    title: "Scarica il tuo materiale",
    body: "Appena completi l'acquisto, tutti i 6 volumi in PDF e i 5 bonus arrivano nella tua casella email. Nessuna app, nessun login, nessuna attesa.",
  },
  {
    icon: BookOpen,
    title: "Scegli la tua ricetta",
    body: "Apri il volume che preferisci e scegli una ricetta. Ognuna ti indica quanto costa prepararla, prima ancora di comprare un ingrediente.",
  },
  {
    icon: CookingPot,
    title: "Prepara il tuo primo cosmetico",
    body: "Pesa gli ingredienti, segui il metodo passo dopo passo e in poco tempo avrai il tuo primo prodotto, fatto con le tue mani.",
  },
];

export const faqs: Faq[] = [
  {
    question: "Le ricette sono oltre 600. Da dove comincio?",
    answer: "Ti consigliamo di partire dal bonus «Il Metodo Base», che spiega come funziona ogni tipologia di prodotto. Poi scegli una ricetta semplice, come un burro corpo montato o uno scrub: richiedono pochi ingredienti e danno subito soddisfazione.",
  },
  {
    question: "Mi serve un'attrezzatura particolare?",
    answer: "No. Basta una bilancia digitale di precisione (meglio se misura 0,1 g), un pentolino per il bagnomaria, ciotole in vetro o acciaio, una spatola e barattoli puliti. Per lozioni e creme è utile un piccolo frullatore a immersione.",
  },
  {
    question: "Dove compro gli ingredienti?",
    answer: "In erboristeria, nei negozi online specializzati in materie prime cosmetiche e in alcuni negozi bio. Molti ingredienti di base, come oli vegetali e burro di karité, sono facili da trovare.",
  },
  {
    question: "Quanto tempo richiede una ricetta?",
    answer: "La maggior parte delle ricette richiede dai 15 ai 30 minuti di preparazione, esclusi i tempi di raffreddamento o di riposo indicati in ogni scheda.",
  },
  {
    question: "Quanto dura un prodotto una volta preparato?",
    answer: "Ogni ricetta indica la durata prevista e come conservare il prodotto. In generale i prodotti senz'acqua (burri, oli, balsami) durano più a lungo, mentre quelli che contengono acqua richiedono un conservante, come spiegato nelle istruzioni.",
  },
  {
    question: "Riceverò qualcosa per posta?",
    answer: "No, si tratta di un prodotto interamente digitale. Non viene spedito nulla: ricevi tutti i file in formato PDF via email.",
  },
  {
    question: "Come ricevo i file?",
    answer: "Subito dopo il pagamento ricevi un'email con il link per scaricare tutti i 6 volumi e i 5 bonus. Se non la trovi, controlla anche la cartella spam o promozioni.",
  },
  {
    question: "Posso usarlo su telefono o tablet?",
    answer: "Sì. I PDF si aprono su smartphone, tablet e computer, senza bisogno di app particolari.",
  },
  {
    question: "Devo stampare qualcosa?",
    answer: "No, puoi consultare tutto dallo schermo. Se preferisci avere le ricette in cucina, puoi stampare solo quelle che ti servono.",
  },
  {
    question: "Posso vendere ciò che preparo?",
    answer: "Puoi usare le ricette anche per un'attività. Ricorda però che in Italia e nell'Unione Europea la vendita di cosmetici è regolata dal Regolamento (CE) n. 1223/2009: prima di vendere servono la valutazione della sicurezza, la notifica sul portale CPNP e un'etichettatura conforme. Il bonus «Vendi i tuoi cosmetici» ti aiuta a orientarti.",
  },
  {
    question: "Si paga una sola volta?",
    answer: "Sì. Paghi 37,00 € una sola volta e il materiale resta tuo. Nessun abbonamento e nessun costo ricorrente.",
  },
];
